/**
 * Lets non-React code (the HTTP layer, the auth service) navigate without importing the router,
 * which would create an import cycle. The router registers itself at start-up.
 */
type Navigator = (to: string) => void;

let navigator: Navigator = (to) => window.location.assign(to);

export function registerNavigator(fn: Navigator): void {
  navigator = fn;
}

export function navigateTo(to: string): void {
  navigator(to);
}
